<template>    
    <ul class="footer">
        <li>本站所有资源为设计师自行整理并上传</li>
        <li>本站对用户上传资源的知识产权状况仅负有形式审查义务</li>
        <li>如有版权问题，请联系41863805@qq.com</li>
        <li>
            本站资源不提供直接下载，请至
            <a href="/download" target="_blank">下载</a>
            页面，下载安装资源管理插件。插件提供更方便的资源使用和管理服务
        </li>
        <li>沪ICP备2025143786号-2</li>
    </ul>
</template>

<script>
    export default{
        name:'KuFooter',
    }
</script>

<style>

.footer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 240px;
    margin-bottom: 96px;
}

.footer li{
    text-decoration: none;
    color: lightgray;
    list-style-type: none;
    line-height: 24px;
}

.footer a{
    color:  #45B5B5;
    text-decoration: none;
}

</style>